import { eventBus } from '@piggybank/core';
import { connect } from 'formik';
import T from 'prop-types';
import React, { Fragment, useEffect, useRef } from 'react';
import { formNameFromKeyPath } from '../../utils';
import { handleChanges, parseExcludedOptions } from './utils';

export const LinkFields = ({
  context,
  excludeOptions,
  formValues,
  formik,
  noInput = true,
  onAdd,
  onChange,
  onRemove,
  renderChildren,
}) => {
  const values = useRef(formValues);

  useEffect(() => {
    values.current = formValues;
  });

  useEffect(() => {
    let unsubscribe;

    if (onChange || onAdd || onRemove) {
      unsubscribe = eventBus.subscribe(action =>
        handleChanges({
          action,
          onAdd,
          onChange,
          onRemove,
          formValues: values.current,
          formik,
        })
      );
    }

    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, []);

  if (excludeOptions) {
    const field = formNameFromKeyPath(context.keyPath).join('.');

    context.excludeOptions = parseExcludedOptions(
      excludeOptions,
      formValues,
      field
    );
  }

  const shouldRender = !!excludeOptions || !noInput;

  return shouldRender ? renderChildren({ context, formValues }) : <Fragment />;
};

LinkFields.propTypes = {
  context: T.shape({
    excludeOptions: T.array,
    keyPath: T.shape({
      inputName: T.string,
    }),
  }),
  noInput: T.bool,
  excludeOptions: T.array,
  formik: T.object.isRequired,
  onChange: T.object,
  onAdd: T.object,
  onRemove: T.object,
  formValues: T.object.isRequired,
  renderChildren: T.func,
};

export default connect(LinkFields);
